export const HC_PHONE_NUMBER = '1-800-317-2739';
export const TEL_PREFIX = 'tel:';